module.exports = __webpack_public_path__ + "static/turquia-017-8f23819ed4e9dbf88c41966a0f7b3da0.jpg";